import React, { useEffect, useState } from "react";
import { Country } from "country-state-city";
import "./checkoutcom.css";
import { useInstructions } from "../../APIContext/InstructionsContext";
import { useNewUser } from "../../APIContext/NewUserContext";
import Swal from "sweetalert2";

const Checkout = () => {
  const {
    fetchCartItems,
    cartItems,
    coupons,
    fetchCoupons,
    applyCoupon,
    proceedToCheckout,
    verifyPaymentStatus,
    removeCupon,
  } = useInstructions();
  const {
    fetchCartItemsNew,
    cartItemsNew,
    fetchCouponsNew,
    couponsNew,
    applyCouponNew,
    removeCuponGuest,
  } = useNewUser();

  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [appliedCouponData, setAppliedCouponData] = useState(null);
  const [isApplying, setIsApplying] = useState(false);
  const [couponMessage, setCouponMessage] = useState({ text: "", type: "" });

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("pending");
  const [paymentMessage, setPaymentMessage] = useState(
    "Verifying your payment...",
  );
  const [pollInterval, setPollInterval] = useState(null);
  const [cartItemsforPage, setCartItemsforPage] = useState([]);
  const [cuponsPage, setCuponsPage] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const user = localStorage.getItem("user");

  function formatDateMMDDYYYY(dateString) {
    const date = new Date(dateString);

    return date.toLocaleDateString(undefined, {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  }

  function capitalizeWords(str) {
    if (!str) return "";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  useEffect(() => {
    if (user) {
      fetchCartItems();
      fetchCoupons();
    } else {
      fetchCartItemsNew();
      fetchCouponsNew();
    }
  }, [refresh]);

  useEffect(() => {
    if (user) {
      setCartItemsforPage(cartItems || []);
      setCuponsPage(coupons || []);
    } else {
      setCartItemsforPage(cartItemsNew || []);
      setCuponsPage(couponsNew || []);
    }
  }, [cartItems, cartItemsNew, coupons, couponsNew, user]);

  useEffect(() => {
    const coupon = cartItemsforPage?.summary?.coupon;

    if (coupon?.code) {
      setAppliedCouponData({
        discounted_price_map: cartItemsforPage?.summary?.total,
        coupon: coupon,
      });

      setCouponMessage({
        text: `Applied: ${capitalizeWords(coupon.name)} (${coupon.discount_value != null ? `${coupon.discount_value}%` : `$${cartItemsforPage?.summary?.discount_amount}`} OFF) Code: ${coupon.code}`,
        type: "success",
      });
    }
  }, [cartItemsforPage]);
  // Filter valid coupons
  const cartPackageIds = cartItemsforPage?.items?.map((item) => item.package);
  const availableCoupons = cuponsPage
    .filter((coupon) => {
      if (
        !coupon.is_active ||
        new Date(coupon.expiry_date) < new Date() ||
        coupon.used_count >= coupon.max_uses
      )
        return false;
      const appliesToAll = coupon.applies_to_all_packages === true;
      const hasMatch = coupon.packages.some((id) =>
        cartPackageIds?.includes(id),
      );
      return appliesToAll || hasMatch;
    })
    .sort(
      (a, b) => parseFloat(b.discount_value) - parseFloat(a.discount_value),
    );

  const handleApplyCoupon = async () => {
    if (!selectedCoupon) return;

    setIsApplying(true);
    setCouponMessage({ text: "", type: "" });

    try {
      const payload = { code: selectedCoupon };

      if (user) {
        await applyCoupon(payload);
      } else {
        await applyCouponNew(payload);
      }

      setRefresh((prev) => !prev);
    } catch (err) {
      setCouponMessage({
        text: err.message || "Failed to apply coupon",
        type: "error",
      });
    } finally {
      setIsApplying(false);
    }
  };

  // const startPaymentPolling = (sessionId) => {
  //     setShowPaymentModal(true);
  //     setPaymentStatus('pending');
  //     setPaymentMessage('Verifying your payment...');

  //     const interval = setInterval(async () => {
  //         try {
  //             const result = await verifyPaymentStatus(sessionId);
  //             if (result[0]?.payment?.paid === true) {
  //                 clearInterval(interval);
  //                 setPaymentStatus('success');
  //                 setPaymentMessage('Payment Successful! Redirecting...');
  //                 setTimeout(() => {
  //                     window.location.href = '/your-packages';
  //                 }, 2500);
  //             }
  //         } catch (err) {
  //             console.log('Still waiting...');
  //         }
  //     }, 3000);

  //     setPollInterval(interval);

  //     setTimeout(() => {
  //         if (paymentStatus === 'pending') {
  //             clearInterval(interval);
  //             setPaymentStatus('failed');
  //             window.location.href = '/payment-failed';
  //             setPaymentMessage('Payment timed out. Contact support.');
  //         }
  //     }, 10 * 60 * 1000);
  // };

  const handleSubmit = async () => {
    if (cartItemsforPage?.items?.length === 0) return alert("Cart is empty!");

    const payload = {
      coupon_code: appliedCouponData?.coupon?.code || "",
      packages: cartItemsforPage?.items?.map((item) => ({
        package_id: item.package,
        player_id: item.player,
      })),
    };

    try {
      const response = await proceedToCheckout(payload);
      if (response?.data?.url) {
        const sessionId = response.data.id;
        const win = window.open(response.data.url, "_self");
        // if (win) startPaymentPolling(sessionId);
        // else alert('Please allow pop-ups!');
      }
    } catch (err) {
      console.error(err);
      alert("Checkout failed");
    }
  };

  const handleRemoveCupon = async () => {
    const result = await Swal.fire({
      title: "Remove Coupon?",
      text: "Are you sure you want to remove the applied coupon?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it",
      cancelButtonText: "No, keep it",
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;
    try {
      if (user) {
        await removeCupon();
      } else {
        await removeCuponGuest();
      }
      setAppliedCouponData(null);
      setSelectedCoupon("");
      setCouponMessage({ text: "", type: "" });

      setRefresh((prev) => !prev);
    } catch (err) {
      console.error("Failed to remove coupon", err);
      alert("Failed to remove coupon");
    }
  };

  console.log(availableCoupons);

  const subtotal = cartItemsforPage?.summary?.subtotal || "00.00";
  const finalTotal = cartItemsforPage?.summary?.total || "00.00";
  useEffect(
    () => () => pollInterval && clearInterval(pollInterval),
    [pollInterval],
  );

  return (
    <>
      <div
        className={`checkout-wrapper brightness ${user ? "full-width" : "half-width"}`}
      >
        {/* ORDER SUMMARY */}
        <div className="checkout-card summary-section">
          <div className="summary-header">
            <span className="header-gold text-clip">PRODUCT</span>
            <span className="header-gold text-clip">TOTAL</span>
          </div>
          <div className="divider"></div>

          {cartItemsforPage?.items?.map((item) => {
            const discounted =
              cartItemsforPage?.summary?.discount_amount || "00.00";
            const original = cartItemsforPage?.summary?.subtotal || "00.00";
            const final = Number(item?.total_price) || "00.00";

            return (
              <div key={item.id} className="summary-item">
                <span className="item-name">
                  <span className="text-clip">
                    {capitalizeWords(item.package_name)}
                    <br />
                  </span>
                  {item.child_details && (
                    <>
                      <small
                        className="text-clip"
                        style={{ "--clip-color": "#888" }}
                      >
                        Player: {capitalizeWords(item.child_details.name) || ""}
                      </small>
                      {item.child_details.date_of_birth && (
                        <small
                          className="text-clip"
                          style={{ "--clip-color": "#888" }}
                        >
                          Date of Birth:{" "}
                          {formatDateMMDDYYYY(item.child_details.date_of_birth)}
                        </small>
                      )}
                      {item.child_details.grade && (
                        <small
                          className="text-clip"
                          style={{ "--clip-color": "#888" }}
                        >
                          Grade: {item.child_details.grade}
                        </small>
                      )}
                      {item.child_details.jersey_size && (
                        <small
                          className="text-clip"
                          style={{ "--clip-color": "#888" }}
                        >
                          Jersey Size: {item.child_details.jersey_size}
                        </small>
                      )}
                      {item.child_details.school_name && (
                        <small
                          className="text-clip"
                          style={{ "--clip-color": "#888" }}
                        >
                          School Name:{" "}
                          {capitalizeWords(item.child_details.school_name)}
                        </small>
                      )}
                    </>
                  )}
                  {/* {discounted && (
                                        <div style={{ marginTop: '6px' }}>
                                            <small style={{ color: '#28a745', fontWeight: 'bold' }}>
                                                Coupon Applied ({cartItemsforPage?.summary?.coupon?.discount_value || "00.00"}% OFF)
                                            </small>
                                        </div>
                                    )} */}
                </span>
                <span className="item-price text-clip">
                  ${final.toFixed(2)}
                  {/* {discounted && (
                                        <del style={{ color: '#999', fontSize: '13px', marginLeft: '8px' }}>
                                            ${original.toFixed(2)}
                                        </del>
                                    )} */}
                </span>
              </div>
            );
          })}

          {/* SINGLE COUPON DROPDOWN */}
          {availableCoupons.length > 0 && (
            <div className="coupon-row" style={{ marginTop: "20px" }}>
              <label className="coupon-label text-clip">Apply Coupon</label>
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                {/* <select
                                    disabled ={cartItemsforPage?.items?.length === 0}
                                    value={selectedCoupon?.id || ''}
                                    onChange={(e) => {
                                        const coupon = availableCoupons.find(c => c.id === parseInt(e.target.value));
                                        setSelectedCoupon(coupon || null);
                                    }}
                                    className="form-select"
                                    style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }}
                                >
                                    <option value="">Select a coupon...</option>
                                    {availableCoupons.map(coupon => (
                                        <option key={coupon.id} value={coupon.id}>
                                            {coupon.name} — {coupon.code} ({coupon.discount_value}% OFF)
                                        </option>
                                    ))}
                                </select> */}

                <input
                  type="text"
                  placeholder="Enter coupon code"
                  value={selectedCoupon}
                  disabled={cartItemsforPage?.items?.length === 0}
                  onChange={(e) => setSelectedCoupon(e.target.value)}
                  className="form-control"
                  style={{
                    flex: 1,
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    textTransform: "uppercase",
                  }}
                />
                <button
                  onClick={handleApplyCoupon}
                  disabled={!selectedCoupon || isApplying}
                  style={{
                    padding: "12px 24px",
                    background:
                      !selectedCoupon || isApplying ? "#ccc" : "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor:
                      !selectedCoupon || isApplying ? "not-allowed" : "pointer",
                    fontWeight: "600",
                    fontSize: "15px",
                    filter: "brightness(0.8)",
                  }}
                >
                  {isApplying ? "Applying..." : "Apply"}
                </button>
              </div>
            </div>
          )}

          {couponMessage.text && (
            <div
              style={{
                padding: "12-loaded",
                margin: "15px 0",
                borderRadius: "8px",
                backgroundColor:
                  couponMessage.type === "success" ? "#d4edda" : "#f8d7da",
                "--clip-color":
                  couponMessage.type === "success" ? "#155724" : "#721c24",
                border: `1px solid ${couponMessage.type === "success" ? "#c3e6cb" : "#f5c6cb"}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
              }}
            >
              <span  style={{ padding: ".75rem" }}>
                {couponMessage.text}
              </span>

              {/* Show Clear button only on success (i.e. when a coupon is actually applied) */}
              {couponMessage.type === "success" && (
                <button
                  onClick={() => {
                    handleRemoveCupon();
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    "--clip-color":
                      couponMessage.type === "success" ? "#155724" : "#721c24",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "14px",
                    padding: "4px 8px",
                    textDecoration: "underline",
                  }}
                  onMouseOver={(e) => (e.target.style.opacity = 0.7)}
                  onMouseOut={(e) => (e.target.style.opacity = 1)}
                >
                  <span>✕ Remove</span>
                </button>
              )}
            </div>
          )}

          <div className="divider"></div>

          <div className="summary-footer">
            <span className="header-gold total-text text-clip">TOTAL</span>
            <span className="total-price">
              <strong className="text-clip">${finalTotal}</strong>
              {appliedCouponData && (
                <>
                  <br />
                  <small
                    className="text-clip"
                    style={{ "--clip-color": "#28a745", fontWeight: "bold" }}
                  >
                    You saved $
                    {(parseFloat(subtotal) - parseFloat(finalTotal)).toFixed(2)}
                  </small>
                  <br />
                  <del
                    className="text-clip"
                    style={{ "--clip-color": "#999", fontSize: "15px" }}
                  >
                    ${subtotal}
                  </del>
                </>
              )}
            </span>
          </div>

          {user ? (
            <button
              disabled={cartItemsforPage?.items?.length === 0}
              type="submit"
              onClick={handleSubmit}
              className="place-order-btn"
            >
              Pay Now – ${finalTotal}
            </button>
          ) : (
            <></>
          )}
        </div>

        {/* <div className="checkout-card billing-section">
          <form onSubmit={handleSubmit}>
            <button type="submit" className="place-order-btn">
              Pay Now – ${finalTotal}
            </button>
          </form>
        </div> */}
      </div>

      {/* PAYMENT MODAL */}
      {showPaymentModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="bg-custom brightness"
            style={{
              padding: "60px 40px",
              borderRadius: "20px",
              textAlign: "center",
              maxWidth: "440px",
              boxShadow: "0 30px 60px rgba(0,0,0,0.4)",
            }}
          >
            {paymentStatus === "pending" && (
              <>
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    border: "10px solid #f0f0f0",
                    borderTop: "10px solid #007bff",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto 30px",
                  }}
                ></div>
                <h3 className="text-clip">Processing Payment</h3>
                <p className="text-clip" style={{ "--clip-color": "#666" }}>
                  {paymentMessage}
                </p>
              </>
            )}
            {paymentStatus === "success" && (
              <>
                <div style={{ fontSize: "90px", color: "#28a745" }}>✅</div>
                <h3 style={{ color: "#28a745" }}>Payment Successful!</h3>
                <p className="text-clip" style={{ "--clip-color": "#212529" }}>
                  {paymentMessage}
                </p>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Checkout;
